import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { InspectionReportComponent } from "./components/inspection-report/inspection-report.component";
import { RouterModule } from "@angular/router";
import { RubblSharedModule } from "../rubbl-shared/rubbl-shared.module";
import { BarcodeScannerComponent } from "./components/barcode-scanner/barcode-scanner.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InspectionFormComponent } from "./components/inspection-form/inspection-form.component";
import { NgbProgressbarModule } from "@ng-bootstrap/ng-bootstrap";
import { RubblFormsModule } from "../forms/forms";

@NgModule({
  declarations: [InspectionReportComponent, BarcodeScannerComponent, InspectionFormComponent],
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, RubblSharedModule, NgbProgressbarModule, RubblFormsModule],
  exports: [InspectionReportComponent, BarcodeScannerComponent, InspectionFormComponent],
})
export class InspectionsModule {}
